// Route Pages
const AccountDisclosures = () => import('../../../components/loans/pages/common/AccountDisclosures.vue')
const AccountDocuments = () => import('../../../components/loans/pages/common/AccountDocuments.vue')
const AccountMonthlyDocuments = () => import('../../../components/loans/pages/common/AccountMonthlyDocuments.vue')
const AccountStatusBlocked = () => import('../../../components/loans/pages/common/AccountStatusBlocked.vue')
const AddDebitDisburseMethod = () => import('../../../components/loans/pages/common/AddDebitDisburseMethod.vue')
const AddPaymentMethod = () => import('../../../components/loans/pages/common/AddPaymentMethod.vue')
const AlternateBlocked = () => import('../../../components/loans/pages/common/AlternateBlocked.vue')
const AltPartyVerifyCode = () => import('../../../components/loans/pages/common/AltPartyVerifyCode.vue')
const AncillaryProducts = () => import('../../../components/loans/pages/common/AncillaryProducts.vue')
const AncillaryProductsConfirm = () => import('../../../components/loans/pages/common/AncillaryProductsConfirm.vue')
const Appointment = () => import('../../../components/loans/pages/common/Appointment.vue')
const CancelRenewal = () => import('../../../components/loans/pages/common/CancelRenewal.vue')
const ConfirmDisbursement = () => import('../../../components/loans/pages/common/ConfirmDisbursement.vue')
const ConfirmPayment = () => import('../../../components/loans/pages/common/ConfirmPayment.vue')
const CustomerDetails = () => import('../../../components/loans/pages/common/CustomerDetails.vue')
const CustomerProfile = () => import('../../../components/loans/pages/common/CustomerProfile.vue')
const Dashboard = () => import('../../../components/loans/pages/common/Dashboard.vue')
const DocuSignView = () => import('../../../components/loans/pages/common/DocuSignView.vue')
const PendingDisbursement = () => import('../../../components/loans/pages/common/PendingDisbursement.vue')
const FeatureUnavailable = () => import('../../../components/loans/pages/common/FeatureUnavailable.vue')
const GetCashAmount = () => import('../../../components/loans/pages/common/GetCashAmount.vue')
const GetCashNotice = () => import('../../../components/loans/pages/common/GetCashNotice.vue')
const GpsLocation = () => import('../../../components/loans/pages/common/GpsLocation.vue')
const GpsLocationDisabled = () => import('../../../components/loans/pages/common/GpsLocationDisabled.vue')
const LoanDocumentUpload = () => import('../../../components/loans/pages/common/LoanDocumentUpload.vue')
const MakePayment = () => import('../../../components/loans/pages/common/MakePayment.vue')
const ManageAccount = () => import('../../../components/loans/pages/common/ManageAccount.vue')
const ManageDisburseMethod = () => import('../../../components/loans/pages/common/ManageDisburseMethod.vue')
const ManagePaymentMethod = () => import('../../../components/loans/pages/common/ManagePaymentMethod.vue')
const OfferDetails = () => import('../../../components/loans/pages/common/OfferDetails.vue')
const Offers = () => import('../../../components/loans/pages/common/Offers.vue')
const OfrVehicleRecovery = () => import('../../../components/loans/pages/common/OfrVehicleRecovery.vue')
const OfrVehicleRepossessed = () => import('../../../components/loans/pages/common/OfrVehicleRepossessed.vue')
const OriginationAmount = () => import('../../../components/loans/pages/common/OriginationAmount.vue')
const OriginationCallMe = () => import('../../../components/loans/pages/common/OriginationCallMe.vue')
const OriginationDocuSign = () => import('../../../components/loans/pages/common/OriginationDocuSign.vue')
const OriginationChooseMethod = () => import('../../../components/loans/pages/common/OriginationChooseMethod.vue')
const PaymentProcessing = () => import('../../../components/loans/pages/common/PaymentProcessing.vue')
const ProductSwitch = () => import('../../../components/loans/pages/common/ProductSwitch.vue')
const ProductSwitchAppointment = () => import('../../../components/loans/pages/common/ProductSwitchAppointment.vue')
const ReviewPayment = () => import('../../../components/loans/pages/common/ReviewPayment.vue')
const SettlementOffer = () => import('../../../components/loans/pages/common/SettlementOffer.vue')
const StoreDetails = () => import('../../../components/loans/pages/common/StoreDetails.vue')
const VerificationCode = () => import('../../../components/common/pages/VerificationCode.vue')
const VerificationMethod = () => import('../../../components/common/pages/VerificationMethod.vue')
const WidgetOffer = () => import('../../../components/loans/pages/common/WidgetOffer.vue')
const AutoPayConfirm = () => import('../../../components/loans/pages/common/AutoPayConfirm.vue')
const AutoPayUpdatePaymentMethod = () => import('../../../components/loans/pages/common/AutoPayUpdatePaymentMethod.vue')

// Route Parents
const GenericParent = () => import('../../../components/common/pages/GenericParent.vue')

export default (brand = '') => {
  return [
    {
      path: 'CustomerProfile',
      name: `${brand}-CustomerProfile`,
      component: CustomerProfile,
      props: true
    },
    {
      path: 'Origination',
      component: GenericParent,
      props: true,
      meta: { flow: 'Origination' },
      children: [
        {
          path: 'OriginationAmount',
          name: `${brand}-OriginationAmount`,
          component: OriginationAmount,
          props: true
        },
        {
          path: 'OriginationCallMe',
          name: `${brand}-OriginationCallMe`,
          component: OriginationCallMe,
          props: true
        },
        {
          path: 'OriginationChooseMethod',
          name: `${brand}-OriginationChooseMethod`,
          component: OriginationChooseMethod,
          props: true
        },
        {
          path: 'OriginationDocuSign',
          name: `${brand}-OriginationDocuSign`,
          component: OriginationDocuSign,
          props: true
        },
        {
          path: 'AddDebitDisburseMethod',
          name: `${brand}-AddDebitDisburseMethodOrigination`,
          component: AddDebitDisburseMethod,
          props: true
        },
        {
          path: 'ManageDisburseMethod',
          name: `${brand}-ManageDisburseMethodOrigination`,
          component: ManageDisburseMethod,
          props: true
        }
      ]
    },
    {
      path: 'Offers',
      component: GenericParent,
      props: true,
      meta: { flow: 'Offers' },
      children: [
        {
          path: '',
          name: `${brand}-Offers`,
          component: Offers,
          props: true
        },
        {
          path: 'OfferDetails',
          name: `${brand}-OfferDetails`,
          component: OfferDetails,
          props: true
        },
        {
          path: 'WidgetOffer',
          name: `${brand}-WidgetOffer`,
          component: WidgetOffer,
          props: true
        }
      ]
    },
    {
      path: 'FeatureUnavailable',
      name: `${brand}-FeatureUnavailable`,
      component: FeatureUnavailable,
      props: true
    },
    {
      path: 'PaymentMethods',
      component: GenericParent,
      props: true,
      meta: { flow: 'PaymentMethods' },
      children: [
        {
          path: '',
          name: `${brand}-ManagePaymentMethod`,
          component: ManagePaymentMethod,
          props: true
        },
        {
          path: 'AddPaymentMethod',
          name: `${brand}-ManageAddPaymentMethod`,
          component: AddPaymentMethod,
          props: true
        }
      ]
    },
    {
      path: 'Stores',
      component: GenericParent,
      props: true,
      meta: { flow: 'Stores' },
      children: [
        {
          path: ':storeId',
          component: GenericParent,
          props: true,
          meta: { flow: 'Store' },
          children: [
            {
              path: '',
              name: `${brand}-StoreDetails`,
              component: StoreDetails,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: 'Accounts',
      component: GenericParent,
      props: true,
      meta: { flow: 'Accounts' },
      children: [
        {
          path: '',
          name: `${brand}-Dashboard`,
          component: Dashboard,
          props: true
        },
        {
          path: ':loanId',
          name: `${brand}-AccountDetails`,
          component: Dashboard,
          props: true,
          meta: { flow: 'Account' }
        },
        {
          path: ':loanId',
          component: GenericParent,
          props: true,
          meta: { flow: 'Account' },
          children: [
            {
              path: 'Documents/:lmsId',
              name: `${brand}-Documents`,
              component: AccountDocuments,
              props: true
            },
            {
              path: 'AccountMonthlyDocuments',
              name: `${brand}-AccountMonthlyDocuments`,
              component: AccountMonthlyDocuments,
              props: true
            },
            {
              path: 'AlternateBlocked',
              name: `${brand}-AlternateBlocked`,
              component: AlternateBlocked,
              props: true
            },
            {
              path: 'Appointment',
              name: `${brand}-Appointment`,
              component: Appointment,
              props: true
            },
            {
              path: 'Pending',
              component: GenericParent,
              props: true,
              meta: { flow: 'Pending' },
              children: [
                {
                  path: '',
                  name: `${brand}-AccountStatusBlocked`,
                  component: AccountStatusBlocked,
                  props: true
                },
                {
                  path: 'DocumentUpload',
                  name: `${brand}-LoanDocumentUpload`,
                  component: LoanDocumentUpload,
                  props: true
                }
              ]
            },
            {
              path: 'ManageAccount',
              name: `${brand}-ManageAccount`,
              component: ManageAccount,
              props: true
            },
            {
              path: 'Payment',
              component: GenericParent,
              props: true,
              meta: { flow: 'Payment' },
              children: [
                {
                  path: 'OfrVehicleRecovery',
                  name: `${brand}-OfrVehicleRecovery`,
                  component: OfrVehicleRecovery,
                  props: true
                },
                {
                  path: 'OfrVehicleRepossessed',
                  name: `${brand}-OfrVehicleRepossessed`,
                  component: OfrVehicleRepossessed,
                  props: true
                },
                {
                  path: '',
                  name: `${brand}-MakePayment`,
                  component: MakePayment,
                  props: true
                },
                {
                  path: 'ProductSwitch',
                  name: `${brand}-ProductSwitch`,
                  component: ProductSwitch,
                  props: true
                },
                {
                  path: 'ReviewPayment',
                  name: `${brand}-ReviewPayment`,
                  component: ReviewPayment,
                  props: true
                },
                {
                  path: 'SettlementOffer',
                  name: `${brand}-SettlementOffer`,
                  component: SettlementOffer,
                  props: true
                },
                {
                  path: 'SelectPaymentMethod',
                  name: `${brand}-SelectPaymentMethod`,
                  component: ManagePaymentMethod,
                  props: true
                },
                {
                  path: 'AddPaymentMethod',
                  name: `${brand}-PaymentAddPaymentMethod`,
                  component: AddPaymentMethod,
                  props: true
                },
                {
                  path: 'PaymentProcessing',
                  name: `${brand}-PaymentProcessing`,
                  component: PaymentProcessing,
                  props: true,
                  meta: {
                    paymentFlowPage: true
                  }
                },
                {
                  path: 'ProductSwitchAppointment',
                  name: `${brand}-ProductSwitchAppointment`,
                  component: ProductSwitchAppointment,
                  props: true,
                  meta: {
                    paymentFlowPage: true,
                    preventNavigation: [
                      `${brand}-AccountDisclosures`,
                      `${brand}-DocuSignView`
                    ]
                  }
                },
                {
                  path: 'CancelRenewal',
                  name: `${brand}-CancelRenewal`,
                  component: CancelRenewal,
                  props: true
                },
                {
                  path: 'ConfirmPayment',
                  name: `${brand}-ConfirmPayment`,
                  component: ConfirmPayment,
                  props: true,
                  meta: {
                    paymentFlowPage: true,
                    preventNavigation: [
                      `${brand}-DocuSignView`,
                      `${brand}-AccountDisclosures`,
                      `${brand}-ProductSwitchAppointment`
                    ]
                  }
                },
                {
                  path: 'CustomerDetails',
                  name: `${brand}-CustomerDetails`,
                  component: CustomerDetails,
                  props: true
                },
                {
                  path: 'AltPartyVerifyCode',
                  name: `${brand}-AltPartyVerifyCode`,
                  component: AltPartyVerifyCode,
                  props: true
                },
                {
                  path: 'Code',
                  name: `${brand}-VerificationCode`,
                  component: VerificationCode,
                  props: true
                },
                {
                  path: 'AccountDisclosures',
                  name: `${brand}-AccountDisclosures`,
                  component: AccountDisclosures,
                  meta: {
                    paymentFlowPage: true
                  }
                },
                {
                  path: 'AncillaryProducts',
                  name: `${brand}-AncillaryProducts`,
                  component: AncillaryProducts,
                  meta: {
                    paymentFlowPage: true
                  }
                },
                {
                  path: 'AncillaryProductsConfirm',
                  name: `${brand}-AncillaryProductsConfirm`,
                  component: AncillaryProductsConfirm,
                  meta: {
                    paymentFlowPage: true
                  }
                },
                {
                  path: 'DocuSignView',
                  name: `${brand}-DocuSignView`,
                  component: DocuSignView,
                  props: true,
                  meta: {
                    paymentFlowPage: true,
                    preventNavigation: [
                      `${brand}-AccountDisclosures`
                    ]
                  }
                },
                {
                  path: 'PendingDisbursement',
                  name: `${brand}-PendingDisbursement`,
                  component: PendingDisbursement,
                  props: true,
                  meta: {
                    paymentFlowPage: true,
                    preventNavigation: [
                      `${brand}-DocuSignView`
                    ]
                  }
                },
                {
                  path: 'GetCashAmount',
                  name: `${brand}-GetCashAmount`,
                  component: GetCashAmount,
                  props: true
                },
                {
                  path: 'GetCashNotice',
                  name: `${brand}-GetCashNotice`,
                  component: GetCashNotice,
                  props: true
                },
                {
                  path: 'ManageDisburseMethod',
                  name: `${brand}-ManageDisburseMethodPayment`,
                  component: ManageDisburseMethod,
                  props: true
                },
                {
                  path: 'AddDebitDisburseMethod',
                  name: `${brand}-AddDebitDisburseMethodPayment`,
                  component: AddDebitDisburseMethod,
                  props: true
                },
                {
                  path: 'ConfirmDisbursement',
                  name: `${brand}-ConfirmDisbursement`,
                  component: ConfirmDisbursement,
                  meta: {
                    paymentFlowPage: true,
                    preventNavigation: [
                      `${brand}-DocuSignView`,
                      `${brand}-AccountDisclosures`
                    ]
                  }
                },
                {
                  path: 'VerificationMethod',
                  name: `${brand}-RefiVerificationMethod`,
                  component: VerificationMethod,
                  props: true
                },
                {
                  path: 'GpsLocation',
                  name: `${brand}-GpsLocation`,
                  component: GpsLocation,
                  props: true
                },
                {
                  path: 'GpsLocationDisabled',
                  name: `${brand}-GpsLocationDisabled`,
                  component: GpsLocationDisabled,
                  props: true
                },
                {
                  path: 'AutoPayConfirm',
                  name: `${brand}-AutoPayConfirm`,
                  component: AutoPayConfirm,
                  props: true
                },
                {
                  path: 'AutoPayUpdatePaymentMethod',
                  name: `${brand}-AutoPayUpdatePaymentMethod`,
                  component: AutoPayUpdatePaymentMethod,
                  props: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
